import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'antd/lib/slider';

export default class CalculatorSlider extends Component {
  static propTypes = {
    formatter: PropTypes.func.isRequired,
    tipFormatter: PropTypes.func,
    value: PropTypes.number,
    onChange: PropTypes.func,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
  };

  render() {
    const { formatter, min, max, step, value, tipFormatter } = this.props;

    const sliderMarks = {
      [min - 1]: <span>{formatter(min)}</span>,
      [max + 1]: <span>{formatter(max)}</span>,
    };

    const _tipFormatter = tipFormatter || formatter || null;

    return (
      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        marks={sliderMarks}
        included={false}
        tipFormatter={_tipFormatter}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/CalculatorSlider.js